import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useHistory } from "react-router";
import { motion } from "framer-motion";
import Popover from "@mui/material/Popover";
import Select from "react-select";
import IRMenu from "./IRMenu";
import AuthorizedCapitalModal from "./AuthorizedCapitalModal";
import IssuedCapitalPage from "./IssuedCapitalModal";
import DeletePopup from "../../../myfin_v2/elements/DeletePopup";
import SuccessPopup from "../../../myfin_v2/elements/SuccessPopup";
import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close_grey.svg";
import { ReactComponent as LeftArrowIcon } from "../../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as DotIcon } from "../../../myfin_v2/assets/icons/dot.svg";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as MenuDotsIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as DownGreyIcon } from "../../../myfin_v2/assets/icons/down_grey.svg";
import {
    getShareCapital, getLinkedCompanies, deleteAuthorizedCapital, deleteIssuedCapital, getInvestmentRegisterForms, updateAuthorizedCapital, updateIssuedCapital
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";

const customSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#ffffff',
        borderColor: '#c2e6d1',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderRadius: '6px',
        '&:hover': {
            borderColor: '#c2e6d1',
        },
        minHeight: '37px',
        height: '37px',
        borderWidth: '1px',
        cursor: 'text',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0 8px',
        display: 'flex',
        alignItems: 'center',
    }),
    input: (provided) => ({
        ...provided,
        color: '#111',
        margin: 0,
        padding: 0,
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '14px',
        margin: 0,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#111',
        fontSize: '14px',
        margin: 0,
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#c2e6d1',
        padding: '4px',
        ':hover': {
            color: '#4f665f',
        },
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        marginTop: '6px',
        zIndex: 9999,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '6px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: (state.isSelected || state.isFocused) ? '#f4faf5' : 'transparent',
        color: '#111',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        borderRadius: '4px',
        marginBottom: '2px',
        fontWeight: (state.isSelected || state.isFocused) ? 600 : 400,
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};

const ShareCapital = () => {

    const { irId } = useParams();
    const history = useHistory();

    const classOfShareOptions = ["Equity", "Preference", "Lease Leability"];
    const relationshipOptions = ["Director", "Investor", "Promoter", "Employee", "Affiliate"];

    const [anchorEl, setAnchorEl]                                             = useState(null);
    const [openAuthorizedCapitalPopoverId, setOpenAuthorizedCapitalPopoverId] = useState(null);
    const [selectedAuthorizedCapital, setSelectedAuthorizedCapital]           = useState(null);
    const [authorizedModalOpen, setAuthorizedModalOpen]                       = useState(false);
    const [authorizedModalType, setAuthorizedModalType]                       = useState(null);
    const [issuedCapitalAnchorEl, setIssuedCapitalAnchorEl]                   = useState(null);
    const [openIssuedCapitalPopoverId, setOpenIssuedCapitalPopoverId]         = useState(null);
    const [selectedIssuedCapital, setSelectedIssuedCapital]                   = useState(null);

    // ← NEW: full-screen page state instead of modal
    const [showIssuedCapitalPage, setShowIssuedCapitalPage]                   = useState(false);
    const [issuedCapitalPageType, setIssuedCapitalPageType]                   = useState(null);

    const [isEditing, setIsEditing]                                           = useState(false);
    const [isIssuedEditing, setIsIssuedEditing]                               = useState(false);
    const [authorizedCapital, setAuthorizedCapital]                           = useState([]);
    const [issuedCapital, setIssuedCapital]                                   = useState([]);
    const [editableRows, setEditableRows]                                     = useState([]);
    const [editableIssuedRows, setEditableIssuedRows]                         = useState([]);
    const [showSearch, setShowSearch]                                         = useState(false);
    const [companySearch, setCompanySearch]                                   = useState("");
    const [selectedCompany, setSelectedCompany]                               = useState(null);
    const [showHeaderSearch, setShowHeaderSearch]                             = useState(false);
    const [headerSearchValue, setHeaderSearchValue]                           = useState("");
    const [companyList, setCompanyList]                                       = useState([]);
    const [linkedCompanies, setLinkedCompanies]                               = useState([]);
    const [deletePopup, setDeletePopup]                                       = useState({ isOpen: false, id: null, type: null });
    const [successPopup, setSuccessPopup]                                     = useState({ isOpen: false, message: "" });
    const [registerName, setRegisterName]                                     = useState("");

    useEffect(() => {
        if (!irId) return;
        getLinkedCompanies(irId)
            .then((res) => {
                const companies = res.data?.companies || [];
                setCompanyList(companies);
                setLinkedCompanies(companies);
            })
            .catch((err) => console.error("Failed to fetch linked companies:", err));

        getInvestmentRegisterForms(irId)
            .then(res => setRegisterName(res.data?.investmentRegister?.name || "Investment Register"))
            .catch(err => console.error(err));
    }, [irId]);

    const filteredCompanies = companyList.filter((c) =>
        c.company_name.toLowerCase().includes(companySearch.toLowerCase())
    );

    const fetchShareCapitalData = async () => {
        try {
            const res = await getShareCapital(irId, selectedCompany._id);
            if (res.data.success) {
                const authCap   = res.data.sharedCapital.authorizedCapital || [];
                const issuedCap = res.data.sharedCapital.issuedCapital     || [];
                setAuthorizedCapital(authCap);
                setIssuedCapital(issuedCap);
                setEditableRows(authCap);
                setEditableIssuedRows(issuedCap);
            }
        } catch (error) {
            console.log("Error fetching Share Capital:", error);
        }
    };

    useEffect(() => {
        if (filteredCompanies.length > 0 && !selectedCompany) {
            setSelectedCompany(filteredCompanies[0]);
        }
    }, [filteredCompanies]);

    useEffect(() => {
        if (selectedCompany) fetchShareCapitalData();
    }, [selectedCompany?._id]);

    useEffect(() => {
        const closeSearch = (e) => {
            if (!e.target.closest(`.${investmentRegisterCss.companyPanelHeader}`)) {
                setShowSearch(false);
            }
        };
        document.addEventListener("click", closeSearch);
        return () => document.removeEventListener("click", closeSearch);
    }, []);

    // ── Authorized Capital handlers ───────────────────────────────────────────
    const handleMenuClick  = (event, id) => { setAnchorEl(event.currentTarget); setOpenAuthorizedCapitalPopoverId(id); };
    const handleClose      = ()          => { setAnchorEl(null); setOpenAuthorizedCapitalPopoverId(null); };
    const handleEdit       = (item)      => { setSelectedAuthorizedCapital(item); setAuthorizedModalType("edit"); setAuthorizedModalOpen(true); handleClose(); };
    const handleModalClose = ()          => { setAuthorizedModalOpen(false); setSelectedAuthorizedCapital(null); setAuthorizedModalType(null); };
    const handleAdd        = ()          => { setSelectedAuthorizedCapital(null); setAuthorizedModalType("add"); setAuthorizedModalOpen(true); };

    const handleDeleteClick = (id, type) => {
        setDeletePopup({ isOpen: true, id, type });
        if (type === "authorized") handleClose();
        if (type === "issued") handleIssuedCapitalPopoverClose();
    };

    const handleConfirmDelete = async () => {
        const { id, type } = deletePopup;
        setDeletePopup({ isOpen: false, id: null, type: null });

        try {
            if (type === "authorized") {
                const res = await deleteAuthorizedCapital(irId, id);
                if (res.status === 200) {
                    setSuccessPopup({ isOpen: true, message: "Authorized capital removed." });
                    fetchShareCapitalData();
                }
            } else if (type === "issued") {
                const res = await deleteIssuedCapital(irId, id);
                if (res.status === 200) {
                    setSuccessPopup({ isOpen: true, message: "Issued capital removed." });
                    fetchShareCapitalData();
                }
            }
        } catch (err) {
            console.error(err);
            swal("Error", "Delete failed", "error");
        }
    };

    const handleAuthorizedSave = async () => {
        try {
            const promises = editableRows.map((row) => {
                const original = authorizedCapital.find(r => r._id === row._id);
                if (
                    original &&
                    (original.classOfShare !== row.classOfShare ||
                     original.noOfShares !== row.noOfShares ||
                     original.faceValue !== row.faceValue ||
                     original.amount !== row.amount)
                ) {
                    const payload = { ...row };
                    // delete payload._id;
                    delete payload._id;
                    delete payload.createdAt;
                    delete payload.updatedAt;
                    return updateAuthorizedCapital(irId, row._id, payload);
                }
                return null;
            }).filter(Boolean);

            if (promises.length > 0) {
                await Promise.all(promises);
                setSuccessPopup({ isOpen: true, message: "Authorized capital updated successfully" });
                fetchShareCapitalData();
            } else {
                setSuccessPopup({ isOpen: true, message: "No changes detected" });
            }
            setIsEditing(false);
        } catch (error) {
            console.error("Failed to update authorized capital:", error);
            swal("Error", error?.response?.data?.error || error?.response?.data?.message || "Failed to update authorized capital", "error");
        }
    };

    const handleIssuedSave = async () => {
        try {
            const promises = editableIssuedRows.map((row) => {
                const original = issuedCapital.find(r => r._id === row._id);
                if (
                    original &&
                    (original.shareHolderName !== row.shareHolderName ||
                     original.relationship !== row.relationship ||
                     original.classOfShare !== row.classOfShare ||
                     original.noOfShares !== row.noOfShares ||
                     original.faceValue !== row.faceValue ||
                     original.amount !== row.amount ||
                     original.holdingPercentage !== row.holdingPercentage)
                ) {
                    const payload = { ...row };
                    // delete payload._id;
                    delete payload._id;
                    delete payload.createdAt;
                    delete payload.updatedAt;
                    delete payload.shareHolderCompanyData;
                    delete payload.shareHolderCompanyID;
                    return updateIssuedCapital(irId, row._id, payload);
                }
                return null;
            }).filter(Boolean);

            if (promises.length > 0) {
                await Promise.all(promises);
                setSuccessPopup({ isOpen: true, message: "Issued capital updated successfully" });
                fetchShareCapitalData();
            } else {
                setSuccessPopup({ isOpen: true, message: "No changes detected" });
            }
            setIsIssuedEditing(false);
        } catch (error) {
            console.error("Failed to update issued capital:", error);
            swal("Error", error?.response?.data?.error || error?.response?.data?.message || "Failed to update issued capital", "error");
        }
    };

    const handleAuthorizedChange = (id, field, value) =>
        setEditableRows((prev) => prev.map((row) => row._id === id ? { ...row, [field]: value } : row));

    // ── Issued Capital handlers ───────────────────────────────────────────────
    const handleIssuedCapitalPopoverClick = (event, id) => { setIssuedCapitalAnchorEl(event.currentTarget); setOpenIssuedCapitalPopoverId(id); };
    const handleIssuedCapitalPopoverClose = ()          => { setIssuedCapitalAnchorEl(null); setOpenIssuedCapitalPopoverId(null); };

    // ← CHANGED: open full-screen page instead of modal
    const handleIssuedCapitalEdit = (item) => {
        setSelectedIssuedCapital(item);
        setIssuedCapitalPageType("edit");
        setShowIssuedCapitalPage(true);
        handleIssuedCapitalPopoverClose();
    };

    const handleAddIssuedCapital = () => {
        setSelectedIssuedCapital(null);
        setIssuedCapitalPageType("add");
        setShowIssuedCapitalPage(true);
    };

    const handleIssuedCapitalPageClose = () => {
        setShowIssuedCapitalPage(false);
        setSelectedIssuedCapital(null);
        setIssuedCapitalPageType(null);
    };

    const handleIssuedChange = (id, field, value) =>
        setEditableIssuedRows((prev) => prev.map((row) => row._id === id ? { ...row, [field]: value } : row));

    const open = Boolean(anchorEl);

    const displayAuthorizedRows = editableRows.filter((item) => {
        if (!headerSearchValue) return true;
        const search = headerSearchValue.toLowerCase();
        return (
            (item.classOfShare && item.classOfShare.toLowerCase().includes(search)) ||
            (item.noOfShares && item.noOfShares.toString().includes(search)) ||
            (item.faceValue && item.faceValue.toString().includes(search)) ||
            (item.amount && item.amount.toString().includes(search))
        );
    });

    const displayIssuedRows = editableIssuedRows.filter((item) => {
        if (!headerSearchValue) return true;
        const search = headerSearchValue.toLowerCase();
        return (
            (item.shareHolderName && item.shareHolderName.toLowerCase().includes(search)) ||
            (item.relationship && item.relationship.toLowerCase().includes(search)) ||
            (item.classOfShare && item.classOfShare.toLowerCase().includes(search)) ||
            (item.noOfShares && item.noOfShares.toString().includes(search)) ||
            (item.faceValue && item.faceValue.toString().includes(search)) ||
            (item.amount && item.amount.toString().includes(search)) ||
            (item.holdingPercentage && item.holdingPercentage.toString().includes(search))
        );
    });

    // Removed early return for IssuedCapitalPage to render it as a modal overlay instead

    return (
        <>
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu activeTab={"Share Capital"} registerID={irId} />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout}
                >
                    {/* ── Header Area ── */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        {/* ── Breadcrumbs ── */}
                        <div className={investmentRegisterCss.iDHeader} style={{ padding: "10px 0px 10px 0px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px" }}>
                                <Link to={`/detailsIR/${irId}`} style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
                                    <LeftArrowIcon height={12} style={{ marginBottom: "2px", marginRight: "10px" }} />
                                    <span style={{ color: "#4D6D64", fontWeight: "500" }}>Investments</span>
                                </Link>
                                <DotIcon style={{ margin: "0 4px" }} />
                                <Link to={`/detailsIR/${irId}`} style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
                                    <span style={{ color: "#4D6D64", fontWeight: "500" }}>{registerName}</span>
                                </Link>
                                <DotIcon style={{ margin: "0 4px" }} />
                                <span style={{ color: "#111", fontWeight: "600" }}>Share Capital</span>
                            </div>
                        </div>

                        {/* ── Header Actions ── */}
                        <div className={investmentRegisterCss.iRHeader}>
                            {showHeaderSearch ? (
                                <div className={investmentRegisterCss.headerSearchBar}>
                                    <SearchIcon className={investmentRegisterCss.headerSearchBarIcon} />
                                    <input autoFocus type="text" className={investmentRegisterCss.headerSearchInput} placeholder="Type something..." value={headerSearchValue} onChange={(e) => setHeaderSearchValue(e.target.value)} />
                                    <CloseIcon className={investmentRegisterCss.headerSearchClose} onClick={() => { setShowHeaderSearch(false); setHeaderSearchValue(""); }} />
                                </div>
                            ) : (
                                <SearchIcon style={{ cursor: "pointer" }} onClick={() => setShowHeaderSearch(true)} />
                            )}
                            <FilterIcon style={{ cursor: "pointer" }} />
                        </div>
                    </div>

                    <div className={investmentRegisterCss.shareCapitalLayout}>

                        {/* ── Company Panel ── */}
                        <div className={investmentRegisterCss.companyPanel}>
                            <div className={investmentRegisterCss.companyPanelHeader}>
                                <span className={investmentRegisterCss.companyPanelTitle}>Select Company</span>
                                <span className={investmentRegisterCss.companyPanelSearchIcon}>
                                    <SearchIcon onClick={() => setShowSearch(prev => !prev)} />
                                </span>
                            </div>
                            {showSearch && (
                                <div className={investmentRegisterCss.companySearchInputWrapper}>
                                    <input type="text" className={investmentRegisterCss.companySearchInput} placeholder="Search company..." value={companySearch} onChange={(e) => setCompanySearch(e.target.value)} autoFocus />
                                </div>
                            )}
                            <ul className={investmentRegisterCss.companyList}>
                                {filteredCompanies.map((company) => (
                                    <li
                                        key={company._id}
                                        className={`${investmentRegisterCss.companyListItem} ${selectedCompany?._id === company._id ? investmentRegisterCss.companyListItemActive : ""}`}
                                        onClick={() => setSelectedCompany(company)}
                                        data-tooltip={company.company_name}
                                        title={company.company_name}
                                    >
                                        {company.company_name}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* ── Tables ── */}
                        <div className={investmentRegisterCss.tableLayout}>

                            {/* ── Authorized Capital Table ── */}
                            <div className={investmentRegisterCss.tableConatiner}>
                                <div className={investmentRegisterCss.tableTitle}>
                                    <span>Authorized Capital</span>
                                    {!isEditing ? (
                                        <span className="d-flex gap-1">
                                            <Button btnColor={buttoncss.greyBg} icon={<EditIcon />} class_={investmentRegisterCss.editBtn} onClick={() => setIsEditing(true)} />
                                            <Button btnColor={buttoncss.greyBg} icon={<PlusPrimaryIcon />} class_={investmentRegisterCss.addBtnRow} onClick={handleAdd} />
                                        </span>
                                    ) : (
                                        <div className={investmentRegisterCss.saveCancelWrap}>
                                            <button className={investmentRegisterCss.cancelBtn} onClick={() => { setIsEditing(false); setEditableRows([...authorizedCapital]); }}>Cancel</button>
                                            <button className={investmentRegisterCss.saveBtn} onClick={handleAuthorizedSave}>Save</button>
                                        </div>
                                    )}
                                </div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "left", paddingLeft: "20px" }}>Class of share</th>
                                            <th style={{ textAlign: "right" }}>Number of shares</th>
                                            <th style={{ textAlign: "right" }}>Face value</th>
                                            <th style={{ textAlign: "right" }}>Amount</th>
                                            <th style={{ textAlign: "right", paddingRight: "20px" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {displayAuthorizedRows.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center", padding: "20px", color: "#b3c0bd" }}>No authorized capital data</td>
                                            </tr>
                                        ) : (
                                            displayAuthorizedRows.map((item) => (
                                                <tr key={item._id}>
                                                    <td style={{ textAlign: "left", paddingLeft: "20px" }}>
                                                        {isEditing ? (
                                                            <div style={{ width: "220px", minWidth: "150px" }}>
                                                                <Select 
                                                                    options={classOfShareOptions.map(opt => ({ label: opt, value: opt }))}
                                                                    value={item.classOfShare ? { label: item.classOfShare, value: item.classOfShare } : null}
                                                                    onChange={(selected) => handleAuthorizedChange(item._id, "classOfShare", selected.value)}
                                                                    styles={customSelectStyles}
                                                                    placeholder="Select class of share"
                                                                    isSearchable={true}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                        ) : (item.classOfShare)}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isEditing ? (<input type="number" value={item.noOfShares} className={investmentRegisterCss.inputShare} onChange={(e) => handleAuthorizedChange(item._id, "noOfShares", e.target.value)} placeholder="Enter Number..." />) : (item.noOfShares?.toLocaleString())}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isEditing ? (<input type="number" className={investmentRegisterCss.inputShare} value={item.faceValue} onChange={(e) => handleAuthorizedChange(item._id, "faceValue", e.target.value)} placeholder="Enter Value..." />) : (item.faceValue)}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isEditing ? (<input type="number" className={investmentRegisterCss.inputShare} value={item.amount} onChange={(e) => handleAuthorizedChange(item._id, "amount", e.target.value)} placeholder="Enter Amount..." />) : (item.amount?.toLocaleString())}
                                                    </td>
                                                    <td style={{ textAlign: "right", paddingRight: "20px" }}>
                                                        <MenuDotsIcon style={{ cursor: "pointer" }} onClick={(e) => handleMenuClick(e, item._id)} />
                                                        <Popover 
                                                            open={Boolean(anchorEl) && openAuthorizedCapitalPopoverId === item._id}
                                                            anchorEl={anchorEl}
                                                            onClose={handleClose}
                                                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                        >
                                                            <div className={investmentRegisterCss.irOptions} style={{ width: "160px" }}>
                                                                <span style={{ borderBottom: "1px solid #EAEEED" }} onClick={() => handleEdit(item)}>Edit</span>
                                                                <span onClick={() => handleDeleteClick(item._id, "authorized")}>Delete</span>
                                                            </div>
                                                        </Popover>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* ── Issued Capital Table ── */}
                            <div className={investmentRegisterCss.tableConatiner}>
                                <div className={investmentRegisterCss.tableTitle}>
                                    <span>Issued Capital</span>
                                    {!isIssuedEditing ? (
                                        <span className="d-flex gap-1">
                                            <Button btnColor={buttoncss.greyBg} icon={<EditIcon />} class_={investmentRegisterCss.editBtn} onClick={() => setIsIssuedEditing(true)} />
                                            <Button btnColor={buttoncss.greyBg} icon={<PlusPrimaryIcon />} class_={investmentRegisterCss.addBtnRow} onClick={handleAddIssuedCapital} />
                                        </span>
                                    ) : (
                                        <div className={investmentRegisterCss.saveCancelWrap}>
                                            <button className={investmentRegisterCss.cancelBtn} onClick={() => { setIsIssuedEditing(false); setEditableIssuedRows([...issuedCapital]); }}>Cancel</button>
                                            <button className={investmentRegisterCss.saveBtn} onClick={handleIssuedSave}>Save</button>
                                        </div>
                                    )}
                                </div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "left", paddingLeft: "20px" }}>Share holder</th>
                                            <th>Relationship</th>
                                            <th>Class of Share</th>
                                            <th style={{ textAlign: "right" }}>No of shares</th>
                                            <th style={{ textAlign: "right" }}>Face value</th>
                                            <th style={{ textAlign: "right" }}>Amount</th>
                                            <th style={{ textAlign: "right" }}>Holding %</th>
                                            <th style={{ textAlign: "right", paddingRight: "20px" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {displayIssuedRows.length === 0 ? (
                                            <tr>
                                                <td colSpan="8" style={{ textAlign: "center", padding: "20px", color: "#b3c0bd" }}>No issued capital data</td>
                                            </tr>
                                        ) : (
                                            displayIssuedRows.map((item) => (
                                                <tr key={item._id}>
                                                    <td style={{ textAlign: "left", paddingLeft: "20px" }}>{item.shareHolderName}</td>
                                                    <td>
                                                        {isIssuedEditing ? (
                                                            <div style={{ width: "200px", minWidth: "120px" }}>
                                                                <Select 
                                                                    options={relationshipOptions.map(opt => ({ label: opt, value: opt }))}
                                                                    value={item.relationship ? { label: item.relationship, value: item.relationship } : null}
                                                                    onChange={(selected) => handleIssuedChange(item._id, "relationship", selected.value)}
                                                                    styles={customSelectStyles}
                                                                    placeholder="Select relationship"
                                                                    isSearchable={true}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                        ) : (item.relationship)}
                                                    </td>
                                                    <td>
                                                        {isIssuedEditing ? (
                                                            <div style={{ width: "200px", minWidth: "120px" }}>
                                                                <Select 
                                                                    options={classOfShareOptions.map(opt => ({ label: opt, value: opt }))}
                                                                    value={item.classOfShare ? { label: item.classOfShare, value: item.classOfShare } : null}
                                                                    onChange={(selected) => handleIssuedChange(item._id, "classOfShare", selected.value)}
                                                                    styles={customSelectStyles}
                                                                    placeholder="Select class"
                                                                    isSearchable={true}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                        ) : (item.classOfShare)}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isIssuedEditing ? (<input type="number" className={investmentRegisterCss.inputShare} value={item.noOfShares} placeholder="Enter Number..." onChange={(e) => handleIssuedChange(item._id, "noOfShares", e.target.value)} />) : (item.noOfShares?.toLocaleString())}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isIssuedEditing ? (<input type="number" className={investmentRegisterCss.inputShare} value={item.faceValue} placeholder="Enter Values..." onChange={(e) => handleIssuedChange(item._id, "faceValue", e.target.value)} />) : (item.faceValue)}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isIssuedEditing ? (<input type="number" className={investmentRegisterCss.inputShare} value={item.amount} placeholder="Enter Amount..." onChange={(e) => handleIssuedChange(item._id, "amount", e.target.value)} />) : (item.amount?.toLocaleString())}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isIssuedEditing ? (<input type="number" className={investmentRegisterCss.inputShare} value={item.holdingPercentage} placeholder="Enter Holding %..." onChange={(e) => handleIssuedChange(item._id, "holdingPercentage", e.target.value)} />) : (`${item.holdingPercentage}%`)}
                                                    </td>
                                                    <td style={{ textAlign: "right", paddingRight: "20px" }}>
                                                        <MenuDotsIcon style={{ cursor: "pointer" }} onClick={(e) => handleIssuedCapitalPopoverClick(e, item._id)} />
                                                        <Popover 
                                                            open={Boolean(issuedCapitalAnchorEl) && openIssuedCapitalPopoverId === item._id}
                                                            anchorEl={issuedCapitalAnchorEl}
                                                            onClose={handleIssuedCapitalPopoverClose}
                                                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                        >
                                                            <div className={investmentRegisterCss.irOptions} style={{ width: "160px" }}>
                                                                <span style={{ borderBottom: "1px solid #EAEEED" }} onClick={() => handleIssuedCapitalEdit(item)}>Edit</span>
                                                                <span onClick={() => handleDeleteClick(item._id, "issued")}>Delete</span>
                                                            </div>
                                                        </Popover>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </motion.div>
            </div>

            {/* Authorized Capital Modal stays as modal — no change */}
            {authorizedModalOpen && (
                <AuthorizedCapitalModal
                    companyId={selectedCompany._id}
                    handleClose={handleModalClose}
                    data={selectedAuthorizedCapital}
                    type={authorizedModalType}
                    classOfShareOptions={classOfShareOptions}
                    investmentID={irId}
                    refreshData={fetchShareCapitalData}
                    onSuccess={(msg) => setSuccessPopup({ isOpen: true, message: msg || "Record saved successfully" })}
                />
            )}
            
            {showIssuedCapitalPage && (
                <IssuedCapitalPage
                    onBack={handleIssuedCapitalPageClose}
                    data={selectedIssuedCapital}
                    type={issuedCapitalPageType}
                    classOfShareOptions={classOfShareOptions}
                    relationshipOptions={relationshipOptions}
                    investmentID={irId}
                    refreshData={fetchShareCapitalData}
                    linkedCompanies={linkedCompanies}
                    companyId={selectedCompany?._id}
                    companyName={selectedCompany?.company_name}
                    onSuccess={(msg) => setSuccessPopup({ isOpen: true, message: msg || "Record saved successfully" })}
                />
            )}

            <DeletePopup
                isOpen={deletePopup.isOpen}
                onConfirm={handleConfirmDelete}
                onCancel={() => setDeletePopup({ isOpen: false, id: null, type: null })}
            />
            
            <SuccessPopup
                isOpen={successPopup.isOpen}
                message={successPopup.message}
                onClose={() => setSuccessPopup({ isOpen: false, message: "" })}
            />
        </>
    );
};

export default ShareCapital;